import React, { Component } from 'react';
import EWH from '../components/EWH';
import { useParams } from "react-router-dom";

function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}


export class ProvinciaComunaliB extends Component {
  render() {
    let { regione, provincia } = this.props.params;
//    let repoTitolo = "/elezioni/withub/electionday-2024/comunali-ballottaggio/" + regione + "/province/" + provincia + "/" + provincia + "-titolo.html";
    let repoDettaglio = "/elezioni/withub/electionday-2024/comunali-ballottaggio/" + regione + "/province/" + provincia + "/" + provincia + ".html";
    let repoFascione = "/elezioni/withub/electionday-2024/comunali-ballottaggio/fascione-osservati.html";
    return (
    <div className="App">
        <EWH id="ewh-dettaglio" repo={repoDettaglio} />
        <EWH id="ewh-fascione" repo={repoFascione} />
    </div>
    )
  }
}

export default withParams(ProvinciaComunaliB)
